var map = {
	"./caramel.png": 2465,
	"./cherry.png": 9963,
	"./coffee.png": 6176,
	"./hazelnut.png": 7799,
	"./strawberry.png": 431,
	"./toffee.png": 3745,
	"./vanilla.png": 4195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3471;